import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { BehaviorSubject, catchError, map, of } from "rxjs";
import Swal from "sweetalert2";
import { ApiService } from "../services/api.service";
import { GigsumoConstants } from "../services/GigsumoConstants";
import { BusinessDataCacheService } from "../services/business-data-cache.service";

export let businessSubject = new BehaviorSubject({});
export let adminSubject = new BehaviorSubject({});


@Injectable({
  providedIn : "root"
})
export class BusinessProvider {

  private businessDetails : any = null;


  setBusiness(d){
    this.businessDetails = d;
  }

  getBusiness(){
    return this.businessDetails;
  }

}



export const businessDetailResolver: ResolveFn<any> =
     (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
      const userId = localStorage.getItem('userId');
      const API = inject(ApiService);
      const cache = inject(BusinessDataCacheService);

      if (!userId) {
        console.warn('No userId found for business resolver');
        businessSubject.next(null);
        localStorage.removeItem('businessRole');
        localStorage.removeItem('businessOwnerId');
        return of(null);
      }

      // Check cache first
      const cacheKey = BusinessDataCacheService.generateBusinessKey(userId);
      const cached = cache.get<any>(cacheKey);

      if (cached) {
        console.log("📦 Business data returned from cache");
        businessSubject.next(cached);

        // Only persist to localStorage if the plan is a paid plan (Growth/Starter/ScaleX)
        const cachedPlan = cached.subscriptionType;
        if (cachedPlan === GigsumoConstants.GrowthPlan ||
            cachedPlan === GigsumoConstants.StarterPlan ||
            cachedPlan === GigsumoConstants.ScaleXPlan) {
          localStorage.setItem('businessRole', cached.role || '');
          localStorage.setItem('businessOwnerId', cached.businessOwner || '');
          localStorage.setItem('contractRoles', JSON.stringify(cached.contractRoles || []));
        } else {
          localStorage.removeItem('businessRole');
          localStorage.removeItem('businessOwnerId');
        }

        return of(cached);
      }

      // Fetch from API if not cached
      console.log("🌐 Fetching business data from API");
      const responsedta = API.query(`business/findUserRoleInBusiness/${userId}`).pipe(
        map(response => {
          console.log("Business data resolved from API", response);

          // Add null/undefined check for response
          if(response && response.code === GigsumoConstants.SUCESSCODE && (response.data?.businessData && (
              response.data.businessData.subscriptionType === GigsumoConstants.GrowthPlan ||
              response.data.businessData.subscriptionType === GigsumoConstants.StarterPlan ||
              response.data.businessData.subscriptionType === GigsumoConstants.ScaleXPlan
            ))){

              const processedData = {
                ...response.data.businessData,
                role: response.data.role,
                contractRoles: response.data.contractRoles || []
              };

              // Cache the processed data
              cache.set(cacheKey, processedData);
              businessSubject.next(processedData);

              // Persist role and plan to localStorage for nav bar visibility across route changes
              localStorage.setItem('businessRole', processedData.role);
              localStorage.setItem('businessOwnerId', processedData.businessOwner || '');
              localStorage.setItem('contractRoles', JSON.stringify(processedData.contractRoles || []));

              return processedData;
            }
            else{
              // Don't cache null responses, might be temporary API issues
              businessSubject.next(null);
              localStorage.removeItem('businessRole');
              localStorage.removeItem('businessOwnerId');
              return null;
            }
        }),
        catchError(error => {
          console.error('Business detail resolver error:', error);
          businessSubject.next(null);
          return of(null);
        })
      );

      return responsedta;
};


export const jobCandidateResolver: ResolveFn<any> =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
     return businessSubject.asObservable();
}



function handleError(e){
  Swal.fire({
    title : "something went wrong!",
    icon : "error",
    text : "please try again later"
  })
  return null;
}


